import { z } from "zod";

export const ctaSchema = z
  .object({
    label: z.string().nullable(),
    url: z.string().nullable(),
    variant: z.enum(["default", "secondary", "ghost"]).nullable(),
    external: z.boolean().nullable(),
    showExternalIcon: z.boolean().nullable(),
  })
  .partial();
